
export default class HeroVideo {

	static getHolderSelectors = () => ['section.hero-video'];


	/**
	 * @param holderElement
	 */
	constructor(holderElement) {
		const video = holderElement.querySelector('video');
		if (video && Hls.isSupported()) {
			const hls = new Hls();
			hls.loadSource(video.dataset.videoUrl);
			hls.attachMedia(video);
			video.play();
		} else if (video && video.canPlayType('application/vnd.apple.mpegurl')) {
			video.src = video.dataset.videoUrl;
			video.play();
		} else if (video) {
			console.warn('HLS is not supported for this browser');
		}
	}
}
